import type { EmblaCarouselType } from 'embla-carousel';
import { useEffect } from 'react';

export function useAutoplayOnInView(
  emblaApi: EmblaCarouselType | undefined,
  inView: boolean,
) {
  useEffect(() => {
    if (!emblaApi) {
      return;
    }

    const autoplay = emblaApi.plugins()?.autoplay;
    if (!autoplay) {
      return;
    }

    //* 슬라이드가 1개 이하이면 embla-autoplay가 초기화를 건너뛰어(내부 delay 미설정) play() 호출 시 크래시한다.
    if (emblaApi.scrollSnapList().length <= 1) {
      return;
    }

    if (inView) {
      autoplay.play();
    } else {
      autoplay.stop();
    }
  }, [emblaApi, inView]);
}
